var juuls = juuls || {};

juuls.pdfUtils = {
    settings: function () {
        return {
            pdfmakeVersion: '0.1.62',

            pageSize: 535,
            pageMargins: [
                30,
                30,
                30,
                30
            ],
            defaultFont: 'OpenSans'
        }
    },
    load: function ( fnCallback ) {
        //Load vendor-scripts for pdf-generator - nested as the pdfMake.js needs to load first
        e4.require.js( e4.settings.ecom.pdfmakeUrl, function () {
            e4.require.js( e4.settings.ecom.vfsfontsUrl, function () {
                e4.require.js( e4.settings.ecom.htmlToPdfmake, function () {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback();
                    }
                } );
            } );
        } );
    },
    model: {
        get: function ( key, model ) {
            if ( key.indexOf( '.' ) === -1 ) {
                return model[ key ];
            }
            else if ( key.indexOf( '.' ) > -1 ) {
                var objSource = model,
                    arrProperties = key.split( '.' ),
                    objReturnValue;
                for ( var i = 0; i < arrProperties.length; i++ ) {
                    var strCurrentPropertyName = arrProperties[ i ],
                        strRemainingPropertyPathAsPropertyName = arrProperties.slice( i ).join( '.' );
                    if ( objSource.hasOwnProperty( strRemainingPropertyPathAsPropertyName ) === true ) {
                        objReturnValue = objSource[ strRemainingPropertyPathAsPropertyName ];
                        break;
                    }
                    else {
                        if ( objSource.hasOwnProperty( strCurrentPropertyName ) === true ) {
                            objSource = objSource[ strCurrentPropertyName ];
                        }
                        else {
                            objReturnValue = undefined;
                            break;
                        }
                    }
                }
                return objReturnValue;
            }
        },
        set: function ( key, value, model ) {
            if ( key.indexOf( '.' ) === -1 ) {
                model[ key ] = value;
            }
            else if ( key.indexOf( '.' ) > -1 ) {
                var arrProperties = key.split( '.' );
                return arrProperties.reduce( function ( objPropertyPath, strCurrentPropertyName, intPropertyPathDepth ) {
                    if ( intPropertyPathDepth === arrProperties.length - 1 ) {

                        objPropertyPath[ strCurrentPropertyName ] = value;
                    }
                    else {
                        if ( objPropertyPath.hasOwnProperty( strCurrentPropertyName ) === false ) {

                            objPropertyPath[ strCurrentPropertyName ] = {};
                        }
                    }
                    return objPropertyPath[ strCurrentPropertyName ];
                }, model );
            }
        }
    },
    image: {
        getDataUri: function ( strUrl, fnCallback ) {
            var image = new Image();
            image.onload = function () {
                var canvas = document.createElement( 'canvas' );
                canvas.width = this.naturalWidth;
                canvas.height = this.naturalHeight;
                canvas.getContext( '2d' ).drawImage( this, 0, 0 );
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( canvas.toDataURL( 'image/png' ) );
                }
            };
            image.onerror = function () {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( juuls.pdfUtils.image.fallback() );
                }

            };
            image.src = strUrl;
        },
        looksLikeDataUri: function(strImage){
            return strImage.indexOf( 'base64' ) > -1;
        },
        handler: function ( image, size ) {
            if ( image.indexOf( '.svg' ) > -1 ) {
                return image;
            }
            return '/admin/public/getimage.ashx?crop=0&image={image}&Height={height}&Width={width}'.replace( '{image}', image ).replace( '{width}', size.width ).replace( '{height}', size.height );
        },
        fallback: function () {
            return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        },
        convertSvg: function(strImageSrc, strImgID, strImgClass){
            var deferred = jQuery.Deferred();
            jQuery.get(strImageSrc, function (data) {
                var jSvg = jQuery(data).find('svg');
                if (typeof strImgID !== 'undefined') {
                    jSvg = jSvg.attr('id', strImgID);
                }
                if (typeof strImgClass !== 'undefined') {
                    jSvg = jSvg.attr('class', strImgClass + ' replaced-svg');
                }
                jSvg = jSvg.removeAttr('xmlns:a');
                deferred.resolve(jSvg);
            }, 'xml');
            return deferred.promise();
        }
    },
    fillArray: function ( value, length ) {
        if ( length === 0 ) {
            return [];
        }
        var a = [ value ];
        while ( a.length * 2 <= length ) {
            a = a.concat( a );
        }
        if ( a.length < length ) {
            a = a.concat( a.slice( 0, length - a.length ) );
        }
        return a;
    },
    getSvgAndTrim: function ( svgPath ) {
        return jQuery.ajax( {
            url: svgPath
        } );
    },
    cleanTableLayout: function () {
        return {
            hLineWidth: function () {
                return 0;
            },
            vLineWidth: function () {
                return 0;
            },
            paddingLeft: function () {
                return 0;
            },
            paddingRight: function () {
                return 0;
            }
        };
    },
    parseHtml: function(strHtml){
        return htmlToPdfmake(strHtml, {
            defaultStyles:{ // change the default styles
                p: {margin:[0, 5, 0, 10], fontSize: 9},
            }
        });
    },
    loader: function ( boolLoad ) {
        if ( boolLoad === true ) {
            jQuery('.js-e-page-loading-overlay').addClass('is-loading');
        }
        else {
            jQuery('.js-e-page-loading-overlay').removeClass('is-loading');
        }
    },
    setFont: function () {
        return {
            OpenSans: {
                normal: 'OpenSans-Regular.ttf',
                bold: 'OpenSans-Bold.ttf',
                italics: 'OpenSans-Italic.ttf',
                bolditalics: 'OpenSans-BoldItalic.ttf'
            }
        };
    },
    build: {
        image: function ( strImageUri, intWidth, arrMargin, strAlignment, strFillColor ) {
            var image = {
                image: strImageUri,
                width: intWidth,
                margin: arrMargin,
                fillColor: strFillColor,
                alignment: strAlignment
            };

            if ( intWidth === 0 ) {
                delete image.width;
            }

            return image;
        },
        svg: function ( strSvg, intWidth, margin = [ 0, 0, 0, 0 ], alignment = 'left' ) {
            return {
                svg: strSvg,
                width: intWidth,
                margin: margin,
                alignment: alignment
            };
        },
        line: function () {
            return {
                canvas: [ {
                    type: 'line',
                    x1: 0,
                    y1: 0,
                    x2: juuls.pdf.settings.pageSize,
                    y2: 0,
                    lineWidth: 1,
                    color: '#888888'
                } ]
            };
        },
        footer: function () {
            return {
                margin: [ 30,
                          0,
                          30,
                          0 ],
                columns: [
                    {
                        width: ( juuls.pdf.settings.pageSize - 60 ) / 2,
                        style: 'productNumber',
                        text: 'Varenummer: '+  juuls.pdf.model.get( 'number' )
                    },
                    {
                        style: 'pageLink',
                        text: juuls.pdf.model.get( 'name' ),
                        link: location.href
                    }
                ]

            };
        }
    },
    styles: {
        default: function () {
            return {
                productName: {
                    fontSize: 24,
                    bold: true,
                    alignment: 'left'
                },
                beforePrice: {
                    fontSize: 26,
                    bold: true,
                    color: '#999',
                    alignment: 'center'
                },
                price: {
                    fontSize: 40,
                    bold: true,
                    alignment: 'center',
                    color: '#4c7902',
                },
                tastenote: {
                    fontSize: 7,
                    color: '#1f1f1f',
                    bold: false,
                    alignment: 'center'
                },
                productNumber: {
                    color: '#999',
                    fontSize: 8
                },
                pageLink: {
                    alignment: 'right',
                    color: '#999',
                    fontSize: 8
                },
                disclaimerText: {
                    fontSize: 8
                },
                header: {
                    fontSize: 8,
                    bold: true
                },
                table: {
                    fontSize: 8
                },
                spec: {
                    fontSize: 10
                },
                copy: {
                    fontSize: 9,
                    margin: [
                        0,
                        15,
                        0,
                        15
                    ]
                },
                small: {
                    fontSize: 8
                }
            };
        }
    }
};